









import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class EstimatePurchaseRow extends Vue {
  @Prop({ required: true }) isShowNoteColumn!: boolean;
}
